import {BaseGraphNode} from "#graph/nodes/base/base-graph-node"
import {circularRefNodeDefinition} from "#graph/nodes/circular-ref/definition"

export class CircularRef extends BaseGraphNode<{
    refId: number
}> {
    public override get definition() {
        return circularRefNodeDefinition
    }
}
